import React from 'react';
import RecoveryRolloutDashboardPage from '../../features/recovery-rollout-dashboard/pages/RecoveryRolloutDashboardPage';
import { AppShell, PageContainer } from '../../features/ui-system';

const AdminRecoveryRolloutDashboard = () => (
  <AppShell>
      <PageContainer>
    <RecoveryRolloutDashboardPage />
              </PageContainer>
    </AppShell>
);

export default AdminRecoveryRolloutDashboard;


